import { ButtonWithIcon } from '@oy/uidesktop';
import { useNavigate } from 'react-router-dom';
import { useTranslate } from 'src/hooks';

function VirtualAccountCreateButton() {
  const navigate = useNavigate();
  const { getTranslation } = useTranslate();
  return (
    <div
      style={{
        flexDirection: 'row',
        display: 'flex',
      }}
    >
      <ButtonWithIcon
        name="createNewVa"
        iconName="add"
        size={ButtonWithIcon.Size.Small}
        onClick={() => {
          navigate('/virtual-account/created/new');
        }}
        style={{ marginRight: '10px' }}
      >
        {getTranslation('pageTitle_createVirtualAccount')}
      </ButtonWithIcon>
    </div>
  );
}

export default VirtualAccountCreateButton;
